import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import type { SearchResultItem } from "@/services/search";
import SearchListItem from "./SearchListItem";

interface Props {
    grouped: {
        specialties: SearchResultItem[];
        proceduresBySpecialty: { [specialtyName: string]: SearchResultItem[] };
    };
    onSelect: (item: SearchResultItem) => void;
}

export default function SearchResults({ grouped, onSelect }: Props) {
    return (
        <>
            {Object.keys(grouped.proceduresBySpecialty).length > 0 && (
                <>
                    {grouped.specialties.length > 0 && <Divider />}
                    {Object.entries(grouped.proceduresBySpecialty).map(
                        ([specialtyName, items]) => (
                            <Box key={specialtyName}>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        px: 2,
                                        py: 1,
                                        bgcolor: "action.hover",
                                        fontWeight: 600,
                                    }}
                                >
                                    {specialtyName}
                                </Typography>
                                {items.map((item) => (
                                    <SearchListItem
                                        key={`${item.type}-${item.slug}`}
                                        item={item}
                                        onClick={onSelect}
                                        primaryWeight={400}
                                        secondary={item.slug.toUpperCase()}
                                    />
                                ))}
                            </Box>
                        ),
                    )}
                </>
            )}
        </>
    );
}
